module.exports = __webpack_public_path__ + "img/aldermore-logo.5020c7cf.svg";